<template>
    <div class="card">
        <div class="card-body">
            <h5 class="card-title">{{settings.title}}</h5>
            <common-chart :settings="settings.chartSettings"></common-chart>
        </div>
    </div>
</template>

<script>
    import CommonChart from './common.chart.vue';
    import * as _ from 'lodash';
    import { randomColor } from 'randomcolor';
    import moment from 'moment';

    export default {
        name: 'CommonWidget',
        components: {
            CommonChart
        },
        props: {
            settings: {
                default: {
                    chartSettings: {},
                    title: "",
                    fetchDataFn: null,
                    mapData: null,
                    labelField: 'label',
                    valueField: 'value',
                }
            }
        },
        data() {
            return {

            }
        },
        mounted(){

            if(this.settings.fetchDataFn && this.$statsService[this.settings.fetchDataFn]){
                this.$statsService[this.settings.fetchDataFn]().then((data) => {
                    let settings = {};
                    if(typeof this.settings.mapData === 'function'){
                        settings = this.settings.mapData(data)
                    }else{
                        settings = {
                            labels: _.map(data, this.settings.labelField),
                            datasets: [{
                                data: _.map(data, this.settings.valueField)
                            }]
                        };
                    }
                    this.settings.chartSettings.data = _.assignIn({}, this.settings.chartSettings.data, settings);
                });
            }
        }
    }

</script>


// WEBPACK FOOTER //
// src/components/stats/charts/common/commonWidget.vue